const popup = $('.sale-popup');
popup.find('.close-popup').click(closePopup);

window.setTimeout(openPopup, 5000);

function openPopup() {
    if(popup) {
        popup.css('opacity', 1);
    }
}

function closePopup() {
    if(popup) {
        popup.css('opacity', 0);   
    }
}